import { IOffer } from '../../../../types/offerData';
import { decorationTypeHelper } from '../../../../utils/decorationTypeHelper';
import { getLandStatusText } from '../../../../utils/land_status_text';
import { getGarageType, getPropertyType } from '../../../../utils/offer_helpers';
import { ParkingTypeNames } from '../../../../utils/parking_type_helpers';

export function getPropertyValueMapper(offer: IOffer) {
  const {
    deadline,
    floorNumber,
    totalArea,
    monthlyIncome,
    land,
    kitchenArea,
    specialty,
    building,
    isOccupied,
    livingArea,
    roomArea,
    bargainTerms,
    coworking,
    decoration,
  } = offer;

  const commercialLandType = land?.status ? getLandStatusText(land.status) : null;

  const garageType = getGarageType(offer);
  const propertyType = getPropertyType(offer);

  return {
    includedAmenities: coworking?.includedAmenities,
    kitchenArea,
    specialty,
    floorsCount: building?.floorsCount,
    totalArea,
    monthlyIncome,
    buildMaterialType: building?.materialType,
    buildYear: building?.buildYear,
    ceilingHeight: building?.ceilingHeight,
    classType: building?.classType,
    columnGrid: building?.columnGrid,
    commercialLandType,
    deadline,
    floorNumber,
    garageType,
    isOccupied,
    landArea: land?.area,
    landStatus: land?.status,
    livingArea,
    minLeaseTerm: bargainTerms.minLeaseTerm,
    parkingType: building?.parking?.type && ParkingTypeNames[building.parking.type],
    parkingPlacesCount: building?.parking?.placesCount,
    propertyType,
    roomArea,
    decoration: decorationTypeHelper(decoration),
  };
}
